"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enableFormSanitization = exports.sanitizeString = void 0;
var REPLACEMENT_SYMBOL = '';
var formFieldIdsForSanitization = ['givenName', 'surname', 'telephoneNumber', 'extension_companyName', 'streetAddress', 'city', 'postalCode', 'VerificationCode'];
var sanitizeString = function sanitizeString(string) {
  return string.replace(/[&<>"()?{}:;'`=\\/]/g, function () {
    return REPLACEMENT_SYMBOL;
  });
};
exports.sanitizeString = sanitizeString;
var sanitizeInput = function sanitizeInput(elementId) {
  var inputElement = document.getElementById(elementId);
  if (inputElement) {
    inputElement.addEventListener('input', function (e) {
      e.target.value = (0, exports.sanitizeString)(e.target.value);
    });
  }
};
var enableFormSanitization = function enableFormSanitization() {
  return formFieldIdsForSanitization.forEach(sanitizeInput);
};
exports.enableFormSanitization = enableFormSanitization;
//# sourceMappingURL=sanitizer.js.map